import { InvoiceForm } from "@/components/InvoiceForm";

export function CreateInvoice(): React.JSX.Element {
  return (
    <>
      <h1 className="text-2xl my-4 font-bold" data-testid="create-invoice-page-title">
        Nauja sąskaita
      </h1>
      <InvoiceForm data-testid="invoice-form" />
    </>
  );
}
